var React = require('react');

function Photo (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":".3"},[React.createElement("path",{"fill":"#3E424E","d":"M12.667 54.889l10-16.667 7.778 8.889 13.333-17.778 15.556 25.556H12.667z","opacity":".1","key":0}),React.createElement("path",{"stroke":"#3E424E","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M66 6H6v60h60V6z","key":1}),React.createElement("path",{"stroke":"#3E424E","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M12.667 54.889l10-16.667 7.778 8.889 13.333-17.778 15.556 25.556H12.667zM26.556 28.223c3.375 0 6.11-2.736 6.11-6.111 0-3.375-2.735-6.111-6.11-6.111-3.375 0-6.111 2.735-6.111 6.11 0 3.376 2.736 6.112 6.11 6.112z","key":2})]));
}

Photo.defaultProps = {"width":"72","height":"72","fill":"none","viewBox":"0 0 72 72"};

module.exports = Photo;

Photo.default = Photo;
